import React from 'react';
import clsx from 'clsx';
import {
  Container, Segment, Header, Icon,
} from 'semantic-ui-react';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import selectors from '@/vocabularies/hooks/selectors';

const UnapprovedPlaceHolder = () => {
  const { title, message, theme } = selectors.useLandingPlaceholder();
  return (
    <Container>
      <Segment
        placeholder
        raised
        className={clsx('aridhia-unapproved-placeholder', `aridhia-theme-${theme}`)}
      >
        <Header as="h2" icon textAlign="center">
          <Icon name="clock" className="primary" circular />
          {title}
          <Header.Subheader>
            <MarkdownRender value={message} />
          </Header.Subheader>
        </Header>
      </Segment>
    </Container>
  );
};

export default UnapprovedPlaceHolder;
